"use client";
import { j as e } from "./index.es44.js";
import { forwardRef as m, useMemo as c } from "react";
import { makeUniqueId as h } from "./index.es126.js";
m(
  ({
    label: d,
    isChecked: o,
    onChange: r,
    isDefaultChecked: a,
    isDisabled: t,
    inputId: i,
    ...l
  }, n) => {
    const s = c(() => h(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: n,
          type: "radio",
          id: i || s,
          onChange: r,
          defaultChecked: a,
          disabled: t,
          checked: o
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: i || s, children: d })
    ] });
  }
);
//# sourceMappingURL=index.es47.js.map
